import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Spin, message, Button, Tag } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import CopyableText from '../../components/CopyableText';
import request from '../../utils/request';

const AssetDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAssetDetail = async () => {
    setLoading(true);
    try {
      const data = await request.get(`/api/explorer/assets/${id}`);
      setAsset(data.asset);
    } catch (error) {
      message.error('加载资产详情失败');
      console.error('Asset detail error:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadAssetDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!asset) {
    return (
      <Card>
        <p>资产不存在</p>
        <Button onClick={() => navigate('/dashboard/explorer')}>返回浏览器</Button>
      </Card>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          返回
        </Button>
      </div>

      <Card title="资产详情">
        <Descriptions column={1} bordered>
          <Descriptions.Item label="名称">{asset.name}</Descriptions.Item>
          <Descriptions.Item label="符号">{asset.symbol}</Descriptions.Item>
          <Descriptions.Item label="精度">{asset.decimals}</Descriptions.Item>
          <Descriptions.Item label="合约地址">
            {asset.contract_address ? <CopyableText text={asset.contract_address} /> : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="所属链">{asset.chain_name}</Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={asset.is_enabled ? 'green' : 'red'}>
              {asset.is_enabled ? '启用' : '禁用'}
            </Tag>
          </Descriptions.Item>
          {asset.minimal_income && (
            <Descriptions.Item label="最小收入金额">
              {parseFloat(asset.minimal_income).toFixed(8)}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
    </div>
  );
};

export default AssetDetail;
